module.exports = __webpack_public_path__ + "static/media/3d-plan_general OrthoStudio V4.d192e490.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general OrthoStudio V4.svg
// module id = 930
// module chunks = 0